import { domain } from './domain'
export const freeWallCreatorURL = `https://${domain}`
